const Settings = {
    videoEncoderCodecs: [
        'hvc1.1.6.L93.90', // H.265/HEVC codec (widely supported)
        'avc1.4d0033', // H.264/AVC codec (widely supported)
        'avc1.420034',
    ],
    videoEncoderBitrateSd: 250_000, // broadcaster upload bw requirement (4x) 1Mbit/s
    videoEncoderBitrateHd: 1_500_000, // broadcaster upload bw requirement (4x) 6Mbit/s
    videoEncoderBitrateUhd: 3_000_000, // broadcaster upload bw requirement (4x) 12Mbit/s
    videoEncoderKeyFrameInterval: 30, // One keyframe per second at 30fps
    videoEncoderDefaultFrameRate: 30, // Changed to 30fps
    videoEncoderDefaultWidth: 1920, // Full HD width
    videoEncoderDefaultHeight: 1080, // Full HD height
    defaultHeartbeatInterval: 30000,
    viewerCounterUpdateInterval: 1000,
    broadcastMetadataInterval: 10000,
    audioSampleRate: 48000,
    audioNumberOfChannels: 1,
    audioCodec: 'opus',
    audioFrameSize: 960,
    audioFrameDurationMicroseconds: 20000,
    maxFragmentSize: 64000, // 64KB - estimated size of protocol headers
    additionalSafetyDelayMillis: 100,
};

export { Settings };
